import styled from 'styled-components'
import ArrowElement from 'components/shared/StyledComponents/ArrowElement'
import { useLoading } from 'components/Loading'

export const StyledTitle = styled.div`
	font-size: 16px;
	line-height: 1.4;
	margin: 0;
	font-weight: 500;
	position: relative;
	display: flex;
	align-items: center;
	${({ isExpanded, canExpand, theme }) => canExpand && `
		cursor: pointer;
		${ArrowElement({ color: theme.primaryColor, isPointedUp: isExpanded })}
	`}
`

export const StyledChildren = styled.div`
	display: ${({ isVisible = true }) => isVisible ? 'block' : 'none'};
	${({ withHeader }) => withHeader && `
		margin-top: 16px;
		&:before {
			content: '';
			display: block;
			min-width: 100%;
			height: 1px;
			margin-left: -10px;
			margin-right: -10px;
			margin-bottom: 20px;
			background-color: #fff;
		}
	`
}`

const StyledContentBase = styled.div`
	background-color: ${({ theme }) => theme.darkbgColor};
	box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.2);
	// Increased bottom padding for placing the bottommost fields error
	padding: ${({ isExpanded }) => isExpanded ? '16px 20px 30px 20px' : '16px 20px'};
	border-radius: 4px;
	transition: margin-top 0.3s;
	:not(:first-child) {
		margin-top: ${({ related }) => related ? 5 : 10}px;
	}
	${({ canExpand, isExpanded, topBorder, theme, nested }) => (topBorder || (canExpand && !nested)) && `
		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: 50%;
			width: 0;
			height: 1px;
			background: ${theme.primaryColor};
			transform: translateX(-50%);
		}
	`}
	${({ canExpand, isExpanded, topBorder, theme }) => ((topBorder || canExpand) && isExpanded) && `
		&:before {
			transition: width 0.3s;
			width: 100%;
		}
	`}
	${({ canExpand }) => !canExpand && `
		:last-of-type {
			flex-grow: 1;
		}
	`}
	${({ canExpand, isExpanded }) => isExpanded && canExpand && `
		flex-grow: 1;
	`}
	${({ isExpanded }) => isExpanded && useLoading}
`
export const StyledContentBlock = styled(StyledContentBase)`
	position: relative;
	${StyledContentBase} {
		background: #fff;
		box-shadow: 0 1px 2px 0 rgba(90, 90, 90, 0.12);
		border-radius: 3px;
		${StyledTitle} {
			font-size: 14px;
			font-weight: ${({ isExpanded }) => isExpanded ? 400 : 500};
			&:before {
				content: '';
				display: block;
				width: 5px;
				height: 5px;
				margin-right: 10px;
				border-radius: 50%;
				background: ${({ theme }) => theme.primaryColor};
			}
		}
		${StyledChildren}:before {
			background-color: rgba(195, 195, 195, 0.2);
		}
	}
`

export const StyledAdditionalSwitcher = styled.div`
	position: absolute;
	bottom: 20px;
	right: 10px;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background: ${({ theme }) => theme.primaryColor};
	box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.2);
	cursor: pointer;
	z-index: 10;
	&:hover {
		background-color: #575d6d;
		box-shadow: 0 2px 2px 0 rgba(151, 151, 151, 0.35);
	}
	${() => ArrowElement({ color: '#fff', isPointedUp: true })}
`
